module.exports = __webpack_public_path__ + "img/xmasParty8.97a8dae4.jpg";